/**
 * Remembers the last same-store page visited and uses it for the cart
 * "Continue shopping" link. Falls back to /collections when unavailable.
 */
(function () {
  var STORAGE_KEY = 'lp_cart_continue_url';

  function getConfig() {
    var routes = (window.theme && window.theme.routes) || {};
    return {
      cartPath: routes.cartPage || '/cart',
      fallback: routes.collections || '/collections'
    };
  }

  function toStorePath(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.pathname + parsed.search;
    } catch (e) {
      return null;
    }
  }

  function isBlockedPath(path, cartPath) {
    if (path === cartPath || path.indexOf(cartPath + '/') === 0) {
      return true;
    }
    if (path === '/checkout' || path.indexOf('/checkout/') === 0) {
      return true;
    }
    return false;
  }

  function isValidStorefrontUrl(url, config) {
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.origin !== window.location.origin) {
        return false;
      }
      return !isBlockedPath(parsed.pathname, config.cartPath);
    } catch (e) {
      return false;
    }
  }

  function isCartPage(config) {
    var path = window.location.pathname;
    return path === config.cartPath || path.indexOf(config.cartPath + '/') === 0;
  }

  function saveCurrentPage() {
    var config = getConfig();
    if (isValidStorefrontUrl(window.location.href, config)) {
      var storePath = toStorePath(window.location.href);
      if (storePath) {
        sessionStorage.setItem(STORAGE_KEY, storePath);
      }
    }
  }

  function getContinueUrl(config) {
    var stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored && isValidStorefrontUrl(stored, config)) {
      return stored;
    }

    if (document.referrer && isValidStorefrontUrl(document.referrer, config)) {
      var fromReferrer = toStorePath(document.referrer);
      if (fromReferrer) {
        sessionStorage.setItem(STORAGE_KEY, fromReferrer);
        return fromReferrer;
      }
    }

    return config.fallback;
  }

  function updateCartLink() {
    var container = document.querySelector('[data-cart-continue-browsing]');
    if (!container) {
      return;
    }

    var link = container.querySelector('a');
    if (link) {
      link.href = getContinueUrl(getConfig());
    }
  }

  function init() {
    var config = getConfig();
    if (isCartPage(config)) {
      updateCartLink();
    } else {
      saveCurrentPage();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
